import { z } from "zod";

z.config({
  customError: (iss) => {
    const { code, expected, input } = iss;

    switch (code) {
      case "invalid_type":
        if (!input) {
          return `Input is required`;
        }

        return `Input must be ${expected}`;

      case "too_small":
        if (iss.type === "string") {
          return `Input must be at least ${iss.minimum} characters long`;
        }
        if (iss.type === "number") {
          return `Input must be at least ${iss.minimum}`;
        }
        return `Input is too short`;

      case "too_big":
        if (iss.type === "string") {
          return `Input must be at most ${iss.maximum} characters long`;
        }
        if (iss.type === "number") {
          return `Input must be at most ${iss.maximum}`;
        }
        return `Input is too large`;

      case "custom":
        return iss.message || `Input is invalid`;

      default:
        return `Input is invalid`;
    }
  },
});
